import * as Scrivito from "scrivito";

const siteIds = {
  DE: "dc07b5fb5abd4c35",
  EN: "56a14d0750cc844e",
};

export default function configureScrivito(options) {
  const config = {
    adoptUi: true,
    autoConvertAttributes: true,
    optimizedWidgetLoading: true,
    strictSearchOperators: true,
    contentTagsForEmptyAttributes: false,
    tenant: import.meta.env.SCRIVITO_INSTANCE_ID,
    baseUrlForSite() {
      return import.meta.env.SCRIVITO_ORIGIN;
    },
    siteForUrl() {
      const language = import.meta.env.LANGUAGE;
      const siteId = siteIds[language] || siteIds.EN;

      return { siteId, baseUrl: import.meta.env.SCRIVITO_ORIGIN };
    },
  };

  if (import.meta.env.SCRIVITO_ENDPOINT) {
    config.endpoint = import.meta.env.SCRIVITO_ENDPOINT;
  }

  if (options?.priority) {
    config.priority = options.priority;
  }
  // eslint-disable-next-line no-console
  console.log({ config });

  Scrivito.configure(config);
}
